import { render } from "./page_unavailable.vue?vue&type=template&id=424f1b45&scoped=true"
import script from "./page_unavailable.vue?vue&type=script&lang=js"
export * from "./page_unavailable.vue?vue&type=script&lang=js"

import "./page_unavailable.vue?vue&type=style&index=0&id=424f1b45&scoped=true&lang=css"

import exportComponent from "../../../../../../../../../Users/martijn/Documents/GitHub/dfm/DFM-user-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-424f1b45"]])

export default __exports__